/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthUpdateLanguageRequest, AuthUpdateLanguageResponse } from '../types/AuthUpdateLanguage'

/**
 * PATCH /auth/me/language
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::updateLanguage
 */
export async function authUpdateLanguage(
	data: AuthUpdateLanguageRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthUpdateLanguageResponse>> {
	return axiosInstance.patch('/auth/me/language', data, config)
}
